import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { history } from './redux/store/history';
import {
    LoginAdmin, TopAdmin, UserCtrl, UserEdit, NoticeCtrl, NoticeEdit, RecordCtrl,
    TopTrainer, CommentEdit, SubjectManage, NativeAppNotice , CloseNotice
} from './app/containers/pages'
import { PrivateRoute } from './PrivateRoot';

import { USERTYPE } from './app/common/constants.js';
import { ErrorDialog, MaintenanceDialog } from './app/components/molecues';

class Root extends Component {
    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route exact path='/nativeappnotice' component={NativeAppNotice} />
                    <Route exact path='/admin' component={LoginAdmin} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/top' component={TopAdmin} />
                    <PrivateRoute permission={[USERTYPE.ADMIN, USERTYPE.TRAINER]} exact path='/admin/user' component={UserCtrl} />
                    <PrivateRoute permission={[USERTYPE.ADMIN, USERTYPE.TRAINER]} exact path='/admin/user-edit' component={UserEdit} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/notice' component={NoticeCtrl} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/notice-edit' component={NoticeEdit} />
                    <PrivateRoute permission={[USERTYPE.ADMIN]} exact path='/admin/record' component={RecordCtrl} />
                    <PrivateRoute permission={[USERTYPE.TRAINER]} exact path='/admin/trainer/top' component={TopTrainer} />
                    <PrivateRoute permission={[USERTYPE.TRAINER]} exact path='/admin/trainer/comment-edit' component={CommentEdit} />
                    <PrivateRoute permission={[USERTYPE.TRAINER]} exact path='/admin/trainer/subject' component={SubjectManage} />
                    <Route component={CloseNotice} />
                </Switch>
                <ErrorDialog />
                <MaintenanceDialog />
            </Router>
        );
    }
}

export { Root };